export const paginate = (data = [], page = 1, pageSize = 10) => {
  const start = (page - 1) * pageSize;
  const end = start + pageSize;

  return {
    items: data.slice(start, end),
    total: data.length,
    page,
    pageSize,
  };
};

export const NoLeads = ({ text = "No leads available" }) => (
  <div
    style={{
      padding: "40px 16px",
      textAlign: "center",
      color: "#999",
      fontSize: 14,
    }}
  >
    {text}
  </div>
);